import axios from "axios";
import type { OriginalInfo, ContactInfoConfirPayload, ContactInfoPayload, UpdatedConactInfo } from "../../types";
import { MAIN_URL, Subdomains, UserEndpoints } from "../../constants";

axios.defaults.withCredentials = true;

export async function getContactInfo(args: { regNum: number; lan: string }) {
  const { regNum, lan } = args;
  return await axios<ContactInfoPayload>({
    method: "GET",
    url: `${MAIN_URL}${Subdomains.contactInfo}${UserEndpoints.getContactInfo}/${regNum}/${lan}`,
  });
}

export async function confirmContactInfoAPI(args: {
  contactInfo: OriginalInfo;
  updatedContactInfo: UpdatedConactInfo;
  paneemEmail: string | null;
  lan: string;
}) {
  return await axios<ContactInfoConfirPayload>({
    method: "POST",
    data: args,
    url: `${MAIN_URL}${Subdomains.contactInfo}${UserEndpoints.confirmContactInfo}/${args.lan}`,
  });
}
